import { render, staticRenderFns } from "./Photos.vue?vue&type=template&id=580ea17b"
import script from "./Photos.vue?vue&type=script&lang=js"
export * from "./Photos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports